export default "__VITE_PUBLIC_ASSET__f2c9d7b9__"